import * as types from "../types";
import backend from "../api/api";
import history from "../history";
import { store } from "../store";
import { message } from "antd";

const getConfig = () => {
  const token = store.getState().auth.token;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  return config;
};

export const createfeature = (formValues) => async (dispatch) => {
  try {
    const response = await backend.post(
      `api/ecommerce/feature/`,
      formValues,
      getConfig()
    );
    if (response.status === 201) {
      return response.data;
    }
  } catch (error) {
    alert(error);
  }
};

export const getAllfeature = () => async (dispatch) => {
  try {
    const response = await backend.get("api/ecommerce/feature/", getConfig());
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSpecificfeature = (id) => async (dispatch) => {
  try {
    const response = await backend.get(
      `api/ecommerce/feature/${id}/`,
      getConfig()
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const updatefeature = (id, formValues) => async (dispatch) => {
  try {
    const response = await backend.put(
      `api/ecommerce/feature/${id}/`,
      formValues,
      getConfig()
    );
    if (response.status === 202) {
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export const deletefeature = (id) => async (dispatch) => {
  try {
    const response = await backend.delete(
      `api/ecommerce/feature/${id}/`,
      getConfig()
    );
    if (response.status === 204) {
      return true;
    }
  } catch (error) {
    console.log(error);
  }
};
